
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GUID"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"firstname"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lastname"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"phone"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"email"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"verified"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"emailVerified"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"phoneVerified"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"identityVerified"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ubbleVerificationStatus"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"linkedBankAccount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"needToUpdateIban"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"birthdate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sponsoredUserNbr"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"active"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ageVerified"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"identityNameAlert"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"totalLoanCapacity"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"leftLoanCapacity"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"identityDuplication"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"createdAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"loggedAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ubbleIdentityId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ubbleVerificationAttempts"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fraudSuspicion"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"adminAuthorization"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"blockingExpiresAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"biLinkStatus"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"biLinkError"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"amlCftAlert"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"commonName"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"device"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brand"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"baseOs"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"readableVersion"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fraudSuspicion"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"riskScore"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"riskBalance"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"score"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"fraudScoring"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fraudSuspicion"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"score"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"biConnectionsSummary"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ownerId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bankAccountsNbr"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":945}};
    doc.loc.source = {"body":"query getUser($id: GUID!) {\n  getUser(id: $id) {\n    user {\n      id\n      firstname\n      lastname\n      phone\n      email\n      verified\n      emailVerified\n      phoneVerified\n      identityVerified\n      ubbleVerificationStatus\n      linkedBankAccount\n      needToUpdateIban\n      birthdate\n      sponsoredUserNbr\n      active\n      ageVerified\n      identityNameAlert\n      totalLoanCapacity\n      leftLoanCapacity\n      identityDuplication\n      createdAt\n      loggedAt\n      ubbleIdentityId\n      ubbleVerificationAttempts\n      fraudSuspicion\n      adminAuthorization\n      blockingExpiresAt\n      biLinkStatus\n      biLinkError\n      amlCftAlert\n      commonName\n    }\n    device {\n      brand\n      baseOs\n      readableVersion\n      fraudSuspicion\n    }\n    riskScore {\n      riskBalance\n      score\n    }\n    fraudScoring {\n      fraudSuspicion\n      score\n    }\n  }\n  biConnectionsSummary(ownerId: $id) {\n    bankAccountsNbr\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["getUser"] = oneQuery(doc, "getUser");
        
